<template>
  <div>
    <baseaktarim
      :logo="null"
      :title="this.SatisKanali + '-' + this.$t('Transfer-Reservations')"
      v-model="items"
      v-on:aktar="Aktar"
      :status="status"
      :tarihfield="true"
      :menuitems="menuItems"
      v-on:menuclick="menuClick"
    >
    </baseaktarim>
    <v-dialog
      v-model="dialogayarlar"
      scrollable=""
      persistent=""
      max-width="400px"
    >
      <v-card color="grey lighten-5">
        <v-card-title> {{SatisKanali}} {{ $t("Definitions") }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('URL-Template')"
                v-model="BokingAgoraAyar.URLSablon"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Branch')"
                v-model="BokingAgoraAyar.Branch"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Channel-Code')"
                v-model="BokingAgoraAyar.ChannelCode"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Channel-Pasword')"
                v-model="BokingAgoraAyar.ChannelPassword"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Agency-Code')"
                v-model="BokingAgoraAyar.AgencyCode"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Agency-Accounting-Code')"
                v-model="BokingAgoraAyar.AgencyAccountingCode"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Currentcode_label')"
                v-model="BokingAgoraAyar.CariKod"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Airline-Code')"
                v-model="BokingAgoraAyar.HavaYoluKodu"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                label="TurOp"
                v-model="BokingAgoraAyar.TurOp"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                :label="$t('Accounting-Type')"
                v-model="BokingAgoraAyar.AccountingType"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="dialogayarlar = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="ayarkaydet()">{{
            $t("save_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import baseaktarim from "../aktarim/coperbaseaktarim";
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  data() {
    return {
      items: [],
      status: tool.NewSatatus(),
      dialogayarlar: false,
      SatisKanali: "BookingAgora",
       BokingAgoraAyar: {
          URLSablon: null,
          Branch: null,
          ChannelCode: null,
          ChannelPassword: null,
          AgencyCode: null,
          AgencyAccountingCode: null,
          CariKod: null,
          TurOp: null,
          AccountingType: null,
          HavaYoluKodu: null,
        },
      menuItems: [
        {
          title: this.$t('Parameters'),
        },
      ],
    };
  },

  components: {
    baseaktarim,
  },
  methods: {
     ParametreOku: ParametreOku,
    menuClick(index) {
      if (index == 0) {
        this.ParametreOku();
      } else if (index == 1) {
      }
    },
    Aktar(date) {

      let params = {
        Tarih: date,
        SatisKanali: this.SatisKanali,
      };

      this.status.loading = true;
      tool.api_post(this, "CoperStream/KPlusStream", params).then(
        (response) => {
          this.items = response.body;
          this.status.loading = false;
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
    ayarkaydet() {
      var params = {
        SatisKanali: this.SatisKanali,
        prm: this.BokingAgoraAyar,
      };

      tool
        .api_post(this, "CoperStream/KPlusParametreWrite", params)
        .then(
          (response) => {
            if (response.body === true) {
              this.text1 = this.$t("Your-settings-have-been-saved");
              this.snackbar = true;
              this.dialogayarlar = false;
            } else {
              this.text1 = this.$t("Error-please-try-again");
              this.snackbar = false;
            }
          },
          (response) => {
            this.text1 = this.$t("Error-please-try-again");
            this.snackbar = false;
          }
        );
    },
  },
};

 function ParametreOku() {
    tool.api_post(this, 'CoperStream/KPlusParametreRead', {SatisKanali: this.SatisKanali}).then((response) => {

      this.BokingAgoraAyar = response.body
     
      this.dialogayarlar = true
    }, (response) => {

      this.text1 = "Ayarlar getirilemedi tekrar deneyiniz."
      this.snackbar = false
    })
  }

</script>
